export default __webpack_public_path__ + "static/media/Captain's Legguards of Heaven's Pass.b2de73a9.jpg";